import { CssBaseline } from '@mui/material';
import {
    createTheme,
    StyledEngineProvider,
    ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';
import { useMemo } from 'react';
import palette from './palette';
import components from './components';
import useSettings from '../hooks/useSettings';
import breakpoints from './breakpoints';
import mixins from './mixins';
import shadows from './shadows';
// import typography from './typography';

export default function ThemeProvider({ children }) {
    const { themeMode } = useSettings();
    const isLight = themeMode === 'light';

    const themeOptions = useMemo(
        () => ({
            mixins,
            breakpoints,
            direction: 'ltr',
            components: isLight ? components.light : components.dark,
            nprogress: { color: isLight ? '#3F51B5' : '#3399FF' },
            palette: isLight ? palette.light : palette.dark,
            props: { MuiBadge: { overlap: 'rectangular' } },
            shadows: isLight ? shadows.light : shadows.dark,
            shape: { borderRadius: 10 },
            typography: {
                fontFamily: 'Nunito',
                button: { textTransform: 'none' },
            },
        }),
        [isLight]
    );

    const theme = createTheme(themeOptions);

    return (
        <StyledEngineProvider injectFirst>
            <MUIThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </MUIThemeProvider>
        </StyledEngineProvider>
    );
}
